<template>
  <Modal v-model="modal" title="修改手机" footer-hide>
    <Steps :current="curStep" size="small" class="edit-mobile">
      <Step title="验证身份"></Step>
      <Step title="绑定新手机"></Step>
      <Step title="修改成功"></Step>
    </Steps>
    <div class="step" v-if="modal">
      <stepOne v-if="curStep === 0" @updataStep="updataStep" />
      <stepTwo v-if="curStep === 1" @updataStep="updataStep" />
      <stepThree v-if="curStep === 2" />
    </div>
  </Modal>
</template>

<script>
import stepOne from "./cell/one"
import stepTwo from "./cell/two"
import stepThree from "./cell/three"
export default {
  name: "EditMobile",
  components: {
    stepOne,
    stepTwo,
    stepThree,
  },
  data() {
    return {
      modal: false,
      curStep: 0
    }
  },
  methods: {
    updataStep(num) {
      this.curStep = num
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-mobile{
  width: 100%;
  padding: 16px;
}
.step{
  margin-top: 10px;
  padding: 0 16px;
}
</style>